// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2ifQT","col":"Table_col__xtaZo","fulfillmentStatus":"Table_fulfillmentStatus__1ziCz","emailCol":"Table_emailCol__1P0B7"};